import { jsxs, jsx } from 'react/jsx-runtime';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES, HelpIcon } from '@lemonade-hq/nuis';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useAuAContext } from '../../providers/AuAProvider.esm.js';
import { useCommonI18nContext } from '../../providers/I18nProvider.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      min-width: 110px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    width: 51px;\n    height: 51px;\n\n    span {\n        display: none;\n    }\n\n    svg {\n        transform: translateX(16px) translateY(15.5px);\n        position: static;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      width: 51px;\n      height: 51px;\n\n      span {\n          display: none;\n      }\n\n      svg {\n          transform: translateX(16px) translateY(15.5px);\n          position: static;\n      }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  border: none;\n  right: 20px;\n  bottom: 10px;\n  background: #b4b3b3;\n  color: #434343;\n  border-radius: 50px;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Arial,\n    sans-serif;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  span {\n    padding-top: 2px;\n    padding-left: 2px;\n    font-size: 1.6rem;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var FloatingButton = styled(Flex).attrs({
    as: "button"
})(_templateObject3(), MEDIA_QUERIES.desktop(_templateObject()), MEDIA_QUERIES.tablet(_templateObject1()), MEDIA_QUERIES.mobile(_templateObject2()));
var FloatingAuA = function(props) {
    var s = useCommonI18nContext().s;
    var _useAuAContext = useAuAContext(), open = _useAuAContext.actions.open;
    var openDialog = useCallback(function() {
        open(props);
    }, [
        open,
        props
    ]);
    return /*#__PURE__*/ jsxs(FloatingButton, {
        onClick: openDialog,
        px: [
            "0",
            "0",
            "26px"
        ],
        py: [
            "0",
            "0",
            "13px"
        ],
        children: [
            /*#__PURE__*/ jsx(HelpIcon, {}),
            /*#__PURE__*/ jsx("span", {
                children: s("contact_us.buttonText")
            })
        ]
    });
};

export { FloatingAuA };
